export type UIColor = 'primary' | 'black' | 'white' | 'secondary' | 'tertiary' | 'accent' | 'red' | 'blue' | 'purple' | 'grey' | 'green' | 'yellow';

export const navHeight = 56;
export const drawerWidth = 500;
export const drawerBreakpoint = 600;
